import { render } from "./ProposalSurcharges.vue?vue&type=template&id=2b09b76b&ts=true"
import script from "./ProposalSurcharges.vue?vue&type=script&lang=ts"
export * from "./ProposalSurcharges.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__